define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min'
], function riqUserStateModule(aoflModules) {
  'use strict';
  var storeService = aoflModules.store;
  var objectUtils = aoflModules.objectUtils;
  var mapApiStepsToFrontEnd = {
    heard_about: 'marketingSurvey',
    efficacy: 'efficacy',
    hopes: 'parentExpectations',
    add_child: 'parentWelcome',
    teacher_ftue: 'teacherOnboarding',
    add_child_free: 'freeParentWelcome',
    teacher_manage_students_onBoarding: 'teacherManageStudentsOnBoarding',
    select_grade_level: 'selectGradeLevel',
    select_reading_level_type: 'selectReadingLevelType'
  };

  var state = function state(accessControlService) {
    var NAMESPACE = 'user';
    var ALIAS = 'user';

    var mutations = {
      init: function init() {
        var state = {
          accountType: '',
          groupUuid: '',
          profileUuid: '',
          userUuid: '',
          role: '',
          authenticated: '',
          activeGroups: [],
          reader: {},
          profiles: [],
          accountInfo: {},
          ftue: '',
          inactive: '',
          completedMarketingSurvey: '',
          completedParentExpectations: '',
          teacherRewardsOptIn: ''
        };
        return state;
      },
      update: function update(_moduleState, _payload) {
        return Object.assign({}, _moduleState, _payload);
      },
      updateBillingInfo: function updateBillingInfo(_moduleState, _payload) {
        var userPaymentInfoPayload = Object.assign(
          {},
          _moduleState.accountInfo.userPaymentInfo,
          _payload
        );
        var accountInfoPayload = Object.assign({}, _moduleState.accountInfo, {
          userPaymentInfo: userPaymentInfoPayload
        });
        return Object.assign({}, _moduleState, {
          accountInfo: accountInfoPayload
        });
      },
      setReaderProfile: function setReaderProfile(_moduleState, _payload) {
        var payload = {reader: _payload};
        return Object.assign({}, _moduleState, payload);
      },
      updateReaderProfile: function updateReaderProfile(
        _moduleState,
        _payload
      ) {
        var payload = {profileDetails: _payload};
        return objectUtils.deepAssign(_moduleState, 'reader', payload);
      },
      updateUsername: function updateUsername(_moduleState, _payload) {
        var accountInfoPayload = Object.assign({}, _moduleState.accountInfo, {
          currentEmail: _payload
        });
        return Object.assign({}, _moduleState, {
          accountInfo: accountInfoPayload
        });
      },
      updateOnBoardingStep: function updateOnBoardingStep(_moduleState) {
        const $onboardingStepIndex = _moduleState.$onboardingStepIndex + 1;
        return Object.assign({}, _moduleState, {
          $onboardingStep: _moduleState.$onboardingSteps[$onboardingStepIndex],
          $onboardingStepIndex
        });
      },
      updateProfiles: function updateProfiles(_moduleState, _payload) {
        var payload = {profiles: _payload};
        return Object.assign({}, _moduleState, payload);
      }
    };

    var decorators = [
      function setUserRole(_nextState) {
        var nextState = _nextState;
        var currentState = storeService.getState();

        var hasUserRole =
          nextState[NAMESPACE] && nextState[NAMESPACE].hasOwnProperty('role');
        var hasRoleChanged =
          currentState[NAMESPACE].role &&
          nextState[NAMESPACE].role &&
          currentState[NAMESPACE].role !== nextState[NAMESPACE].role;
        var hasNoDecoratedRole =
          nextState[NAMESPACE].role &&
          nextState[NAMESPACE].role.length > 0 &&
          !nextState[NAMESPACE].hasOwnProperty('$role');

        if (hasUserRole && (hasRoleChanged || hasNoDecoratedRole)) {
          var roleMapping = accessControlService.getApiUserRoleMapping();
          var role = nextState[NAMESPACE].role;
          var mappedRole =
            roleMapping && roleMapping[role] ? roleMapping[role].master : '';
          nextState[NAMESPACE] = Object.assign({}, nextState[NAMESPACE], {
            $role: mappedRole
          });
        }
        return nextState;
      },
      function setTeacherInitials(_nextState) {
        var nextState = _nextState;
        var currentState = storeService.getState();

        var hasName =
          nextState[NAMESPACE] &&
          nextState[NAMESPACE].name &&
          nextState[NAMESPACE].lastName;
        var isTeacher =
          nextState[NAMESPACE].role &&
          nextState[NAMESPACE].role.indexOf('teacher') > -1;
        var hasNameChanged =
          currentState[NAMESPACE].name &&
          nextState[NAMESPACE].name &&
          (currentState[NAMESPACE].name !== nextState[NAMESPACE].name ||
            currentState[NAMESPACE].lastName !== nextState[NAMESPACE].lastName);
        var hasNoInitials = !nextState[NAMESPACE].hasOwnProperty('$initials');
        var needsInitials = hasNameChanged || hasNoInitials;

        if (hasName && isTeacher && needsInitials) {
          var firstInital = nextState[NAMESPACE].name.charAt(0);
          var lastInitial = nextState[NAMESPACE].lastName.charAt(0);
          var initials = (firstInital + lastInitial).toUpperCase() || '';
          nextState[NAMESPACE] = Object.assign({}, nextState[NAMESPACE], {
            $initials: initials
          });
        }
        return nextState;
      },
      function setUserIsOnboarded(_nextState) {
        const state = storeService.getState();

        if (_nextState[NAMESPACE] === state[NAMESPACE]) {
          return _nextState;
        }
        return objectUtils.deepAssign(_nextState, NAMESPACE, {
          isOnboarded: _nextState.user.ftue && _nextState.user.onboardingStep
        });
      },
      _nextState => {
        const state = storeService.getState();
        if (
          _nextState[NAMESPACE].onboardingSteps ===
          state[NAMESPACE].onboardingSteps
        ) {
          return _nextState;
        }
        const onboardingStep = _nextState[NAMESPACE].onboardingStep;
        const onboardingSteps = _nextState[NAMESPACE].onboardingSteps;
        const $onboardingSteps = onboardingSteps
          .map(step => mapApiStepsToFrontEnd[step])
          .filter(step => Boolean(step));
        const $onboardingStep =
          state[NAMESPACE].$onboardingStep ||
          mapApiStepsToFrontEnd[onboardingStep];
        return objectUtils.deepAssign(_nextState, NAMESPACE, {
          $onboardingSteps,
          $onboardingStep,
          $onboardingStepIndex: $onboardingSteps.indexOf($onboardingStep)
        });
      },
      function setUserPages(_nextState) {
        var state = storeService.getState();
        if (_nextState[NAMESPACE] === state[NAMESPACE]) return _nextState;

        const userPreferences = accessControlService.getUserPreferences(
          _nextState.user.$role
        );
        if (userPreferences) {
          return objectUtils.deepAssign(_nextState, NAMESPACE, {
            homepage: userPreferences.homepage,
            logoutDestination: userPreferences.logout.link,
            fallbackPage: userPreferences.fallbackPage
          });
        }
        return _nextState;
      }
    ];

    return {
      namespace: NAMESPACE,
      alias: ALIAS,
      mutations: mutations,
      decorators: decorators
    };
  };

  return state;
});
